export const onCreateIntegrationCredentials = /* GraphQL */ `
  subscription OnCreateIntegrationCredentials(
    $filter: ModelSubscriptionIntegrationCredentialsFilterInput
  ) {
    onCreateIntegrationCredentials(filter: $filter) {
      id
      organizationId
    }
  }
`;
